import React, { memo } from 'react';
import { Button, Col, Modal, ModalBody, ModalFooter, ModalHeader, Row } from 'reactstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import './ConfirmationModal.css';

const ConfirmationModal = memo(
  ({
    isOpen,
    onCancel,
    onConfirm,
    bodyText,
    confirmBtnText,
    closeBtnText,
    ignoreConfirmButton,
    customBodyComponent,
    warning,
    resetBoxComponent,
    disableConfirmBtn,
    headerText,
    close,
    subHeader
  }) => {
    return (
      <Modal isOpen={isOpen} id="warning-modal">
        <ModalHeader className={warning && 'modal-container'}>
          {ignoreConfirmButton || warning ? 'Warning' : headerText ? headerText : "Are you sure?"}
        </ModalHeader>
        <ModalBody>
          <div className="container">
            {resetBoxComponent ? (
              customBodyComponent
            ) : (
              <Row>
                <>
                  <Col lg={2} md={2} sm={6}>
                    <div className="delete-box-icon">
                      <FontAwesomeIcon
                        style={{ width: '40px', height: '40px' }}
                        icon="exclamation-triangle"
                        color="#3b5aa9"
                      />
                    </div>
                  </Col>
                  <Col lg={10} md={10} sm={6}>
                    <h6>{subHeader}</h6>
                    <p>{bodyText}</p>
                  </Col>
                </>
              </Row>
            )}
          </div>
        </ModalBody>
        <ModalFooter>
          <Button
            outline
            id={close ? 'warning-close' : 'warning-cancel'}
            onClick={onCancel}
            style={ignoreConfirmButton ? { marginLeft: 'auto' } : null}
          >
            {close ? `Close` : closeBtnText ? closeBtnText : `Cancel`}
          </Button>
          {!ignoreConfirmButton && (
            <Button color="primary" onClick={onConfirm} disabled={disableConfirmBtn || false}>
              {confirmBtnText || 'Proceed'}
            </Button>
          )}
        </ModalFooter>
      </Modal>
    );
  },
);

export default ConfirmationModal;
